import { isMobileOrTablet } from '@laminar-product/client-commons-core/web';

export const isValueNotSet = (key: string) => !key || key === 'fill';

export const shouldRedirectOnMobile = () =>
  isMobileOrTablet() &&
  !isValueNotSet(import.meta.env.VITE_MOBILE_REDIRECT_URL);
